import { Box, darken, Typography, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useUserStore } from '@roc/feature-app-core';
import { useDocumentStore } from '@roc/feature-documents';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { LoanProcess, shouldHideTaskUploadTab } from '@roc/feature-utils';
import { TooltipOnOverflow } from '@roc/ui';
import { TodoTitleLink } from 'libs/feature-loan-details/src/loanDetails/components/cards/todoActions';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { CustomTaskDialog } from '../customTask/customTaskDialog';
import { useState } from 'react';
import { LineItemUpload } from '@roc/feature-loan-details';
import { GeneralTasksTab } from '../../types/generalTasksTypes';
import { StyledBadge } from '@roc/feature-loans';


const useStyles = makeStyles(theme => ({
  link: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',

    '& a': {
      color: theme.palette.primary.dark,
      fontFamily: 'sans-serif',
      fontSize: '14px',
      fontWeight: 'bold',
    },
  },
}));

export const DocumentIdCell = ({ row }) => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { documentStore } = useDocumentStore();
  const { loanRoutesConfig } = useLoanRoutes();
  const { userStore } = useUserStore();
  const classes = useStyles();
  const theme = useTheme();
  const [openLineItemChat, setOpenLineItemChat] = useState(false);

  const document = documentStore.formatDocument(
    row.document,
    LoanProcess.UNDERWRITING
  );

  const section = document.borrowerId
    ? `${document.borrowerName} ${document.sectionName}`
    : document.collateralId
      ? `${document.collateralAddress} ${document.sectionName}`
      : document.sectionName;

  const getUrl = loanId => {
    return userStore.isNportalUser
      ? '/nportal/#/loan_information/' + loanId
      : loanRoutesConfig.loans(loanId).children.dashboard.url;
  };

  const init = async row => {
    const loanId = row.loanId;
    await documentStore.loanStore.fetchLoanDetails(loanId);
    generalTasksStore.setLoanId(loanId);
  };

  const onClose = () => {
    if (generalTasksStore.tab !== GeneralTasksTab.ALL_TASKS_FOR_LOAN) {
      generalTasksStore.setLoanId(null);
    }
    generalTasksStore.setOpenChatTabForTaskId(null);
    generalTasksStore.applyFilters();
  };

  const title = documentStore.getDisplayDocumentName(
    row?.document?.taskName,
    row?.document
  );

  const info = row?.document?.documentNameSecondLine || null;

  const formattedTitle = `${title} - ${section}`;

  return (
    <Box display="flex" alignItems="center">
      <StyledBadge badgeContent={row?.unreadCountMessages} onClick={(e) => {
        generalTasksStore.setOpenChatTabForTaskId(row?.document.taskId)
        setOpenLineItemChat(true)
      }}>
        <Typography
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            textDecoration: 'underline',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <TodoTitleLink
            document={documentStore.formatDocument(
              row.document,
              LoanProcess.UNDERWRITING
            )}
            loanProcess={LoanProcess.UNDERWRITING}
            init={() => init(row)}
            showUploadLink={true}
            onClose={onClose}
            propertyId={row?.document?.collateralId}
            style={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              color: theme.palette.primary.dark,
              fontFamily: 'sans-serif',
              fontSize: '14px',
              fontWeight: 'bold',
              textDecoration: 'underline'
            }}
          >
            {row?.document.taskId}
          </TodoTitleLink>
        </Typography>
      </StyledBadge>
      {openLineItemChat && (
        <CustomTaskDialog
          title={formattedTitle}
          taskId={document?.taskId}
          open={openLineItemChat}
          dialogContent={
            shouldHideTaskUploadTab(document) ? null : (
              <LineItemUpload document={document} expand={true} />
            )
          }
          handleClose={() => {
            setOpenLineItemChat(false);
            onClose();
          }}
        />
      )}
    </Box>
  );
};
